import { useState, useCallback } from "react";
import {
  createSurvey,
  updateSurvey,
  deleteSurvey,
} from "api/cansurvey/surveyApi";

interface UseSurveyMutationsResult {
  createSurveyMutation: (
    surveyTitle: string,
    surveyContent: string
  ) => Promise<{ surveyId: number; publicToken: string }>;
  updateSurveyMutation: (
    identifier: { surveyId?: number; token?: string },
    surveyTitle: string,
    surveyContent: string
  ) => Promise<void>;
  deleteSurveyMutation: (surveyId: number) => Promise<void>;
  creating: boolean;
  updating: boolean;
  deleting: boolean;
}

export const useSurveyMutations = (): UseSurveyMutationsResult => {
  const [creating, setCreating] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const createSurveyMutation = useCallback(
    async (surveyTitle: string, surveyContent: string) => {
      setCreating(true);
      try {
        return await createSurvey(surveyTitle, surveyContent);
      } finally {
        setCreating(false);
      }
    },
    []
  );

  const updateSurveyMutation = useCallback(
    async (
      identifier: { surveyId?: number; token?: string },
      surveyTitle: string,
      surveyContent: string
    ) => {
      setUpdating(true);
      try {
        await updateSurvey(identifier, surveyTitle, surveyContent);
      } finally {
        setUpdating(false);
      }
    },
    []
  );

  const deleteSurveyMutation = useCallback(async (surveyId: number) => {
    setDeleting(true);
    try {
      await deleteSurvey(surveyId);
    } finally {
      setDeleting(false);
    }
  }, []);

  return {
    createSurveyMutation,
    updateSurveyMutation,
    deleteSurveyMutation,
    creating,
    updating,
    deleting,
  };
};
